import { render, staticRenderFns } from "./LazyContainer.vue?vue&type=template&id=ecd164ac&"
import script from "./LazyContainer.vue?vue&type=script&lang=js&"
export * from "./LazyContainer.vue?vue&type=script&lang=js&"
import style0 from "./LazyContainer.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports